<template>
  <div>
    <p id="ppp">页面跳转中...</p>
  </div>
</template>
<script>
export default {
  created() {
    this.code = this.getUrlKey("code");
    this.login();
    //http://localhost:2204/#/auth?code=87AA1C97ABF8A3B89B3BB6AF7B8EA5128DC73F92A9A80644D7BDFA7B474D437E39139E9C9726B4A23AB5232D94F68CB82FE2110A2F78440F0F77E46F2642BDACCCE2FB1F0617E5765F92A3B55FAB0828D7C4FE0533AEFFF5F8A9DC158D1E1CE4F4E95240907823201676091EC0B6007200FE0BC05B0F6F02759FEB90558AA3C3ECE8D61D648C50DD36B9BBEC623F2A64
    //http://localhost:2201/#/auth?code=03AC4CF2A5F4470E217D5032DE145135446277A263B20957F4CC20F618FB9D731DA60736DDEFD91B19538C915F8D11A0478EFA1B032955E9E8E11506A6BAB78980B3770A14D15595696F12083A183682C798AED7816EF3BD07B8AB79F07160A1B115192944F7F45B025A5CC45E6316A56544FEE1B5385AD8B34FB83E8F1CCED01C3B04C3AC0D70EF696F4993804C550A
    //https://cloud.ly-gps.com/api/auth/sso?accessKey=b2a5aabaf9354f54a31b1bf780f12a90&plat=2
  },
  data() {
    return {
      loginMsg: {
        username: "",
        password: "",
      },
      code: "",
      
    };
  },
  methods: {
    //http://61.143.40.50:59409/gps-api/v1/auth/sso?password=123456&loginName=zhcw
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    login() {
      this.axios({
        method: "post",
        url: this.axios.commonAuth + "/auth/login/sso",
        data: { code: this.code },
      }).then((res) => {
        console.log(res);
        this.loading = false;
        var myData = res.data;
        if (myData.code == 200) {
          var obj = {
            accessToken: myData.data.accessToken,
            platformId: this.axios.plat,
            identityId: myData.data.identityId,
            customerId: myData.data.customerId,
            identityType: myData.data.identityType,
          };
          sessionStorage.setItem(this.axios.plat, JSON.stringify(obj));
          if (this.storagePasspord) {
            this.$refs.moreAcount.save(this.loginMsg);
          } else {
          }
          this.$router.push({
            path: "/carLocate",
            query: { now: 0 },
          });
        } else {
          this.$Message.error(myData.message);
        }
      });
    },
  },
};
</script>
<style lang="">
#ppp {
  width: 100%;
  text-align: center;
  margin-top: 100px;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/auth.vue